module.exports = __webpack_public_path__ + "static/media/Raleway-Black.38b405eb.ttf";